import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { FormsModule } from '@angular/forms';

import 'material-design-icons/iconfont/material-icons.css';
import { AppComponent } from './app.component';
import { BlackTLCDComponent } from './components/black-tlcd/black-tlcd.component';
import { IdleStateComponent } from './components/idle-state/idle-state.component';
import { CheckGreenStateComponent } from './components/check-green-state/check-green-state.component';
import { ThanksStateComponent } from './components/thanks-state/thanks-state.component';
import { DniStateComponent } from './components/dni-state/dni-state.component';
import { InfoPedidoComponent } from './components/info-pedido/info-pedido.component';
import { BoxDebugComponent } from './components/box-debug/box-debug.component';
import { ObstructedComponent } from './components/obstructed/obstructed.component';
import { StartupComponent } from './components/startup/startup.component';
import { BaseComponent } from './components/base/base.component';
import { ErrorComponent } from './components/error/error.component';
import { StatusBoxComponent } from './components/status-box/status-box.component';
import { ActionsBoxComponent } from './components/actions-box/actions-box.component';
import { ViewsBoxComponent } from './components/views-box/views-box.component';
import { InfoPedidoAppComponent } from './components/info-pedido-app/info-pedido-app.component';
import { SanitizationComponent } from './components/sanitization/sanitization.component';

//sessions
import { LocalSession } from './providers/local-session.provider';

//config
import { environment } from './../environments/environment';

import { ThanksDemoComponent } from './components/thanks-demo/thanks-demo.component';

const config: SocketIoConfig = { 
    url: environment.socketIO.url, options: {} 
  };

const appRoutes: Routes = [
  	{ path: 'IdleStateComponent', component: IdleStateComponent },
  	{ path: 'BlackTLCDComponent', component: BlackTLCDComponent },
  	{ path: 'CheckGreenStateComponent', component: CheckGreenStateComponent },
  	{ path: 'OpenBox', component: DniStateComponent },
  	{ path: 'ThanksStateComponent', component: ThanksStateComponent },
  	{ path: 'InfoPedidoComponent', component: InfoPedidoComponent },
    { path: 'BoxDebug', component: BoxDebugComponent },
    { path: 'Obstructed', component: ObstructedComponent },
    { path: 'Startup', component: StartupComponent },
    { path: 'Error', component: ErrorComponent },
    { path: 'StatusBoxComponent', component: StatusBoxComponent },
    { path: 'ActionsBoxComponent', component: ActionsBoxComponent },
    { path: 'ViewsBoxComponent', component: ViewsBoxComponent },
    { path: 'InfoPedidoAppComponent', component: InfoPedidoAppComponent },
    { path: 'Sanitization', component: SanitizationComponent },
    { path: 'Poll', component: ThanksDemoComponent },
    { path: '', redirectTo: '/IdleStateComponent', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    AppComponent,
    BlackTLCDComponent,
    IdleStateComponent,
    CheckGreenStateComponent,
    ThanksStateComponent,
    DniStateComponent,
    InfoPedidoComponent,
    BoxDebugComponent,
    ObstructedComponent,
    StartupComponent,
    BaseComponent,
    ErrorComponent,
    StatusBoxComponent,
    ActionsBoxComponent,
    ViewsBoxComponent,
    InfoPedidoAppComponent,
    SanitizationComponent,
    ThanksDemoComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    SocketIoModule.forRoot(config),
    FormsModule,
    HammerModule
  ],
  providers: [LocalSession],
  bootstrap: [AppComponent]
})
export class AppModule { }
